import { type Ref, ref } from 'vue'
import { defineStore } from 'pinia'
import { getCase, changeCustomer } from '@/common/services/CaseService' //contains specific
import { CaseStatusEnum } from '@/common/types/case'
import { CaseChannelEnum } from '@/common/types/channel'
import { PriorityCodeEnum } from '@/common/types/priorities'
import { type EmergencyCodeEnum } from '@/common/types/emergencies'

export const useCaseStore = defineStore('case', () => {
  const id: Ref<number> = ref(0)
  const reference: Ref<string | undefined> = ref()
  const parent: Ref<number | undefined> = ref()
  const customerId: Ref<number | undefined> = ref()
  const status: Ref<CaseStatusEnum> = ref(CaseStatusEnum.START)
  const wakeupDate: Ref<string | undefined> = ref()
  const priority: Ref<PriorityCodeEnum> = ref(PriorityCodeEnum.MEDIUM)
  const emergency: Ref<EmergencyCodeEnum | null> = ref(null)
  const assigneeUser: Ref<string | undefined> = ref()
  const dueDate: Ref<string> = ref('')
  const dueDateAlert: Ref<string | undefined> = ref()
  const currentChannel: Ref<CaseChannelEnum> = ref(CaseChannelEnum.FORM)
  const currentSkill: Ref<string> = ref('')
  const typology: Ref<string | null> = ref(null)
  const teamCode = ref<UUID | undefined>(undefined)
  const ready: Ref<boolean> = ref(false)
  const loadingError: Ref<boolean> = ref(false)

  async function loadCase(caseId: number) {
    try {
      ready.value = false
      const caseResponse = await getCase(caseId)

      id.value = caseResponse.id
      reference.value = caseResponse.externalReference
      parent.value = caseResponse.parentId
      customerId.value = caseResponse.customerId
      status.value = caseResponse.status
      wakeupDate.value = caseResponse.wakeupDate
      priority.value = caseResponse.priorityCode
      assigneeUser.value = caseResponse.assignee
      dueDate.value = caseResponse.dueDate
      dueDateAlert.value = caseResponse.dueDateAlert
      currentChannel.value = caseResponse.currentChannelCode
      currentSkill.value = caseResponse.currentSkillCode
      if (caseResponse.contactDriverCode) typology.value = caseResponse.contactDriverCode
      if (caseResponse.emergencyCode) emergency.value = caseResponse.emergencyCode
      if (caseResponse.teamCode) teamCode.value = caseResponse.teamCode
    } catch (error) {
      console.log(error)
      loadingError.value = true
    } finally {
      ready.value = true
    }
  }
  // specific
  function moveCustomer(caseId: number, customerId: number) {
    return changeCustomer(caseId, customerId)
  }
  // end specific
  return {
    id,
    reference,
    parent,
    customerId,
    priority,
    emergency,
    status,
    dueDate,
    dueDateAlert,
    currentSkill,
    typology,
    wakeupDate,
    teamCode,
    ready,
    loadingError,
    loadCase,
    moveCustomer, //specific
  }
})
